import { Component, OnDestroy, OnInit } from '@angular/core';
import { formatDistance } from 'date-fns';
import { FormControl } from '@angular/forms';
import moment from 'moment';
import { NotificationType } from 'src/@smartmanufacturing/common/enum';
import { MessagingService } from 'src/backend/services/messaging.service';
import { NotificationService } from 'src/backend/services/notification.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NotificationItem } from 'src/backend/models/notifications/notification-item';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnDestroy {
  currentDate: any = moment().format("MMM DD, YYYY  h:mm:ss");
  AM_PM: any = moment().format("A");
  messages: any[] = [];
  public NotificationType = NotificationType;
  currentNotificationFilter: string[] = [];
  private limit = 10;
  private offset = 0;
  private eof = false;
  clockInterval: any;
  displaySidePanel: boolean = false;
  types: any[] = [];
  searchCtrl = new FormControl();
  searchValue: string = '';
  timer = null;
  public currentDataLength: number = 0;
  private destroy$: Subject<void> = new Subject<void>();
  constructor(
    private messagingService: MessagingService,
    private notificationService: NotificationService

  ) { }

  ngOnInit() {
    this.getNotifications();
    this.messagingService.currentMessage$.subscribe(response => {
      if (response) {
        const formatedRes = {
          ...response,
          createdAt: formatDistance(new Date(response.createdAt), new Date(), {
            addSuffix: true,
          })
        }
        this.notificationService.notificationCount$.next(this.messages ? this.messages.filter(x => x.isRead === false).length + 1 : 1);
        this.messages.unshift(formatedRes);
        this.notifiySound();
      }
    });
    this.notificationService.eof$.subscribe(res => {
      this.eof = res;
    })
    this.notificationService.currentDataLength$.subscribe(count => {
      this.currentDataLength = count;
    })
    this.getNotificationTypes();
    this.searchCtrl.valueChanges
    .pipe(takeUntil(this.destroy$))
    .subscribe((value: any) => this.onSearchNotification(value));
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    clearInterval(this.clockInterval);
  }

  onSearchNotification(value: string) {
    if (value) {
      this.searchValue = value;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.messages = [];
        this.offset = 0;
        this.getAllNotification();
      }, 700);
    }
  }


  getNotificationTypes(): void {
    const result = [];
    const keys = Object.keys(this.NotificationType);
    const values = Object.values(this.NotificationType);
    for (let i = 0; i < keys.length; i++) {
      result.push({ key: keys[i], value: values[i] });
    }
    this.types = result;
  }

  startTimeClock(): void {
    this.clockInterval = setInterval(() => {
      this.currentDate = moment().format("MMM DD, YYYY  h:mm:ss");
      this.AM_PM = moment().format("A");
    }, 1000);
  }


  notifiySound(): void {
    let notifyAlert = new Audio();
    notifyAlert.src = 'assets/sounds/notification_sound.mp3';
    notifyAlert.load();
    notifyAlert.play();
  }

  getAllNotification(): void {
    const filteredParams = {
      notificationType: this.currentNotificationFilter.toString(),
      pageIndex: this.offset,
      pageSize: this.limit,
      phrase: this.searchValue
    }
    this.notificationService.getUserNotifications(filteredParams);
  }

  getNotifications(): void {
    this.notificationService.notifications.subscribe(response => {
      this.messages = [...this.messages, ...response?.map((ele) => {
        return {
          ...ele,
          createdAt: formatDistance(new Date(ele.createdAt), new Date(), {
            addSuffix: true,
          })
        }
      })];
    });
  }

  getMessageFromFirebase(): void {
    this.messagingService.currentMessageFromFirebase$.subscribe(response => {
      if (response) {
        const formatedRes = {
          ...response,
          createdAt: formatDistance(new Date(response.createdAt), new Date(), {
            addSuffix: true,
          })
        }
        this.notificationService.notificationCount$.next(this.messages ? this.messages.filter(x => x.isRead === false).length + 1 : 1);
        this.messages.unshift(formatedRes);
        this.notifiySound();
      }
    });
  }
  markAllAsRead(): void {
    const data = this.messages.map(ele => {
      return {
        userId: ele?.userId,
        notificationId: ele?.id
      }
    });
    this.notificationService.markAllAsReadNotification(data).subscribe({
      next: (res) => {
        this.getAllNotification();
      },
      error: ({ error }) => {
        console.log(error);
      }
    })
  }

  onChangeType(event: any, notificationType: string): void {
    if (event.checked) {
      this.currentNotificationFilter.push(notificationType);
    } else {
      this.currentNotificationFilter = this.currentNotificationFilter.filter(x => x !== notificationType);
    }
    this.messages = [];
    this.offset = 0;
    this.getAllNotification();
  }

  goToView(notification: any): void {
    const notify = new NotificationItem();
    notify.id = notification['id'];
    notify.title = notification['title'];
    notify.body = notification['description'];
    notify.type = notification['notificationType'];
    notify.elementId = notification['elementId'];
    this.notificationService.navigateToNotificationTarget(notify);
    this.closeSidePanel();
    const markAsReadData = {
      userCode: notification?.userCode,
      notificationId: notification?.id
    }
    this.notificationService.markAsReadNotification(markAsReadData).subscribe({
      next: (res) => {
        this.refreshNotification();
      },
      error: ({ error }) => { }
    })
  }
  markAsRead(notification: any): void {
    const markAsReadData = {
      userCode: notification?.userCode,
      notificationId: notification?.id
    }
    this.notificationService.markAsReadNotification(markAsReadData).subscribe({
      next: (res) => {
        const found = this.messages.find(x => x.id === notification?.id);
        if (found) {
          found.isRead = true;
        }
      },
      error: ({ error }) => { }
    })
  }

  refreshNotification(): void {
    this.messages = [];
    this.offset = 0;
    this.getAllNotification();
  }

  onClearFilterClicked(): void {
    this.currentNotificationFilter = [];
    this.messages = [];
    this.offset = 0;
    this.searchCtrl.setValue('');
    this.searchValue = '';
    this.getAllNotification();
  }

  showNotificationPanel(): void {
    this.startTimeClock();
    this.displaySidePanel = true;
    this.messages = [];
    this.getAllNotification();
  }

  closeSidePanel(): void {
    this.displaySidePanel = false;
    clearInterval(this.clockInterval);
  }

  onScroll() {
    this.loadMoreData();
  }

  private loadMoreData() {
    this.offset += 1;
    const filteredParams = {
      notificationType: this.currentNotificationFilter.toString(),
      pageIndex: this.offset,
      pageSize: this.limit
    }
    this.notificationService.getUserNotifications(filteredParams);
  }


}
